import { useCallback } from 'react';
import { useQuery } from 'react-query';

import { CommonDependency } from '@/dependency';

export const userSearchV3 = async (
  q?: string,
  is_addr: 0 | 1 = 1,
  // 1 或者 null，默认会匹配 id ; 0，不根据 id 查询，只根据 web3id 或者机构号 name
): Promise<SearchUserRes> => {
  if (!q) {
    return {
      users: [],
    };
  }
  // return request.get(`/user/search_v3`, { q, is_addr });
  return CommonDependency.api.fetchUserSearch({ q, is_addr });
};

type SearchUserRes = {
  users: {
    desc?: UserDesc;
    id: string;
  }[];
};

/**
 * search user 列表
 * @param search
 * @param is_addr 1 或者 null，默认会匹配 id ; 0，不根据 id 查询，只根据 web3id 或者机构号 name
 * @returns
 */
export const useUserSearch = (search?: string, is_addr?: 0 | 1) => {
  const select = useCallback((res: SearchUserRes) => {
    return res.users;
  }, []);

  const query = useQuery(['user-search', search], () => userSearchV3(search, is_addr), {
    enabled: !!search,
    select,
  });
  return query;
};
